import { useTranslator } from 'components/shared/hooks';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

export const TranslateCell = (props: ICellRendererParams) => {
  const trans = useTranslator();
  return <div>{trans(props.value)}</div>;
};
